module.exports = "/_next/static/images/IlloUseCaseActivateCustomerDataHover-b98a477d759ae848c780f46514a3e28b.png";